import CancelledSubscriptionModal from './CancelledSubscriptionModal';
import SkipDeliveryModal from './SkipDeliveryModal';
import { SubscriptionState } from '../../types';

interface SubscriptionModalsProps {
  showSkipModal: boolean;
  setShowSkipModal: (show: boolean) => void;
  handleSkipDelivery: () => Promise<void>;
  nextDeliveryDate?: string | null;
  loading: boolean;
  selectedCancelledSubscription: SubscriptionState | null;
  setSelectedCancelledSubscription: (subscription: SubscriptionState | null) => void;
}

const SubscriptionModals: React.FC<SubscriptionModalsProps> = ({
  showSkipModal,
  setShowSkipModal,
  handleSkipDelivery,
  nextDeliveryDate,
  loading,
  selectedCancelledSubscription,
  setSelectedCancelledSubscription
}) => {
  return (
    <>
      <SkipDeliveryModal
        show={showSkipModal}
        onClose={() => setShowSkipModal(false)}
        onSkip={handleSkipDelivery}
        nextDeliveryDate={nextDeliveryDate || null}
        loading={loading}
      />

      <CancelledSubscriptionModal
        subscription={selectedCancelledSubscription}
        isOpen={!!selectedCancelledSubscription}
        onClose={() => setSelectedCancelledSubscription(null)}
      />
    </>
  );
};

export default SubscriptionModals; 